/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { getContentToolPath } from 'apps/artificial-intelligence/src/Utilities/getContentToolPath';
import { CONFIGURATION } from 'apps/console-core/src/Constants/DxpCapabilities/DxpCapabilityItems.constants';
import { getEventServicePath } from '../Utilities/GetEventServicePath/GetEventServicePath';
import { getEventSubscriptionPath } from '../Utilities/GetEventSubscriptionPath/GetEventSubscriptionPath';

/**
 * The paths for each Configuration screen.
 */
export const screenPaths = {
  aiContentTools: `${CONFIGURATION.path}/ai-content-tools`,
  aiContentToolView: `${CONFIGURATION.path}/ai-content-tool${getContentToolPath()}`,
  configurationDashboard: CONFIGURATION.path,
  damIntegrationDetails: `${CONFIGURATION.path}/dam-integrations/:integrationId`,
  damIntegrations: `${CONFIGURATION.path}/dam-integrations`,
  eventService: getEventServicePath(``),
  eventSubscriptionBuilderCreate: getEventServicePath(getEventSubscriptionPath('create')),
  eventSubscriptionBuilderEdit: getEventServicePath(getEventSubscriptionPath(':subscriptionId')),
  eventSubscriptions: getEventServicePath(getEventSubscriptionPath()),
  jobContexts: `${CONFIGURATION.path}/job-runner/contexts`,
  jobExecutions: `${CONFIGURATION.path}/job-runner/jobs/:name`,
  jobRunner: `${CONFIGURATION.path}/job-runner`,
  jobs: `${CONFIGURATION.path}/job-runner/jobs`,
  serviceSettings: `${CONFIGURATION.path}/service-settings`,
  staticSites: `${CONFIGURATION.path}/static-routing`,
  staticSitesManageRouting: `${CONFIGURATION.path}/static-routing/:url`,
};
